import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from 'src/app/_service/message-service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { VendorService } from 'src/app/_services/vendor.services';
import { TransferType, TransferTypeMapping, TransferTypeSriLanka, TransferTypeSriLankaMapping } from 'src/app/components/Vedors/create-vendor/transfertype.enum';
import { AccountType } from 'src/app/components/Vedors/create-vendor/transfertype.enum';
import { AuthenticationService } from 'src/app/_services';

@Component({
    selector: 'telio-account-details',
    templateUrl: './account-details.component.html',
    styleUrls: ['./account-details.component.scss'],
})
export class AccountDetails implements OnInit {
    createAccount: UntypedFormGroup;
    accountId;
    adminrole: any;
    accountTypes;
    transferTypes;
    clicked = false;
    @Input() vendorId;
    checkedBeforeSubmit = false;
    title;
    disableDisclaimer = false;
    hidePassword = true;

    constructor(readonly translate: TranslateService, private route: ActivatedRoute,
        private toastr: SnackbarService, private router: Router,
        private formBuilder: UntypedFormBuilder, private vendorservice: VendorService,
        private userInfoService: UserInfoService, private authService: AuthenticationService) {
    }

    ngOnInit(): void {
        this.loadAccountForm();
        this.adminrole = this.userInfoService.isAdminGroup();
        this.title = !!this.userInfoService.userDetails.appTitle ? this.userInfoService.userDetails.appTitle : 'TELIOEV'
        if (this.vendorId) {
            this.getaccountDetails();
            if (!this.adminrole) {
                // this.createAccount.disable();
                this.disableDisclaimer = true
            }
        }
    }

    hasUserInput(): boolean {
        for (const control in this.createAccount.controls) {
            if (this.createAccount.controls[control].value) {
                return true;
            }
        }
        return false;
    }

    getaccountDetails() {
        this.vendorservice.getAccount(this.vendorId).subscribe(res => {
            if (res) {
                if (res.id) {
                    this.accountId = res.id;
                    this.createAccount.controls['accountHolderName'].setValue(res.account_holder_name);
                    this.createAccount.controls['accountHolderName'].updateValueAndValidity();
                    this.createAccount.controls['accountNumber'].setValue(res.account_number);
                    this.createAccount.controls['accountNumber'].updateValueAndValidity();
                    this.createAccount.controls['confirmAccountNumber'].setValue(res.account_number);
                    this.createAccount.controls['confirmAccountNumber'].updateValueAndValidity();
                    this.createAccount.controls['accountType'].setValue(res.account_type);
                    this.createAccount.controls['accountType'].updateValueAndValidity();
                    this.createAccount.controls['transferType'].setValue(res.transfer_type);
                    this.createAccount.controls['transferType'].updateValueAndValidity();
                    this.createAccount.controls['transferCode'].setValue(res.transfer_code);
                    this.createAccount.controls['transferCode'].updateValueAndValidity();
                    this.createAccount.controls['branchName'].setValue(res.branch_name);
                    this.createAccount.controls['branchName'].updateValueAndValidity();
                }     
            }
        })
    }

    loadAccountForm() {
        this.createAccount = this.formBuilder.group({
            accountHolderName: [''],
            accountNumber: [''],
            confirmAccountNumber: [''],
            accountType: [''],
            transferType: [''],
            transferCode: [''],
            branchName: [''],
            // GSTNumber: [''],
            // PANNumber: ['']
        }, { validators: this.accountNumberMatchingValidatior.bind(this) });
        this.accountTypes = Object.values(AccountType);
        this.transferTypes =  this.userInfoService.userDetails.prefCountry === 'IN' ?  Object.values(TransferType) : Object.values(TransferTypeSriLanka);

    }

    accountNumberMatchingValidatior(formGroup: UntypedFormGroup) {
        const { value: accountNumber } = formGroup.get('accountNumber');
        const { value: confirmAccountNumber } = formGroup.get('confirmAccountNumber');
        if (accountNumber && confirmAccountNumber)
            if (accountNumber === confirmAccountNumber) {
                formGroup.get('confirmAccountNumber').setErrors(null);
                return null;
            }
            else {
                formGroup.get('confirmAccountNumber').setErrors({ notEquivalent: true });
                return { accountNumberNotMatch: true };

            }
    }

    onAccountSubmit() {
        let accountdetails = this.createAccount.value;
        let empty = null;
        let input: any = {
            "vendor_id": !this.vendorId ? empty : this.vendorId,
        }
        !!accountdetails.accountHolderName && (input["account_holder_name"] = accountdetails.accountHolderName);
        !!accountdetails.accountNumber && (input["account_number"] = accountdetails.accountNumber);
        !!accountdetails.branchName && (input["branch_name"] = accountdetails.branchName);
        // !!accountdetails.transferType && (input["transfer_type"] = accountdetails.transferType);
        if (accountdetails.transferType) {
            const transferTypeMap = this.userInfoService.userDetails.prefCountry === 'IN'? TransferTypeMapping: TransferTypeSriLankaMapping;
            input["transfer_type"] = transferTypeMap[accountdetails.transferType];
        }
        !!accountdetails.transferCode && (input["transfer_code"] = accountdetails.transferCode);
        !!accountdetails.accountType && (input["account_type"] = accountdetails.accountType);
        !!accountdetails.GSTNumber && (input["tax_number"] = accountdetails.GSTNumber);
        // !!accountdetails.PANNumber && (input["pan_number"] = accountdetails.PANNumber);

        if (!this.accountId) {
            this.vendorservice.createAccount(input).subscribe(
                (resp: any) => {
                    if (resp.status_code === 409) {
                        if (resp.body) {
                            this.toastr.error(resp.body);
                        }
                        else {
                            this.toastr.error(resp.status_message)
                            this.clicked = false;
                        }
                    }
                    else if(resp.status_code ===2000){
                        if (resp.body) {
                            this.toastr.error(resp.body);
                        }
                        else {
                            this.toastr.error(resp.status_message)
                            this.clicked = false;
                        } 
                    }
                    else if (!!resp) {
                        this.toastr.success(resp.status_message);
                        // this.router.navigate(['/dashboard/operators', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
                    }
                    else {
                        this.toastr.error(resp.status_message)
                    }
                },
                error => {
                    if (error && error.status == 400)
                        this.toastr.error(error.message);
                    else
                        this.toastr.error(this.translate.instant('responseFailed'));
                    this.clicked = false;
                });
        }
        else {
            // input.id = this.accountId;
            this.vendorservice.updateAccount(input).subscribe(
                (resp: any) => {
                    if (resp.status_code === 409) {
                        if (resp.body) {
                            this.toastr.error(resp.body);
                        }
                        else {
                            this.toastr.error(resp.status_message)
                            this.clicked = false;
                        }
                    }
                    else if(resp.status_code ===2000){
                        if (resp.body) {
                            this.toastr.error(resp.status_message);
                        }
                        else {
                            this.toastr.error(resp.status_message)
                            this.clicked = false;
                        } 
                    }
                    else if (!!resp) {
                        this.toastr.success(resp.status_message);
                        // this.router.navigate(['/dashboard/operators', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
                    }
                    else {
                        this.toastr.error(resp.status_message)
                    }
                },
                error => {
                    this.clicked = false;
                    this.toastr.error(error.message);
                });
        }

    }

    resetAccountmethod() {
        this.createAccount.markAsPristine();
        this.createAccount.markAsUntouched();
        this.createAccount.reset();
    }

    checkBoxStatus(event) {
        return this.checkedBeforeSubmit = event.checked;
    }

    formValidate() : boolean {
       return this.hasUserInput() && this.checkedBeforeSubmit ;
    }

    togglePasswordVisibility() {
        this.hidePassword = !this.hidePassword;
      }
}
